/**
 * Keeps instances that have been loaded or created successfully.
 * Will also reflect updates and deletes
 */
export type EntityState<
  TData extends Record<TIdKey, any>,
  TIdKey extends keyof TData = keyof TData
> = {
  data: TData[];
  version: number;
};

export * from './actions';
